module.exports = __webpack_public_path__ + "img/five9-logo-white.5cc5c4a1.svg";